const PSOrientationBaseController = require('./PSOrientationBaseController');

cc.Class({
    extends: PSOrientationBaseController,

    properties: {
        sync: {
            default: false,
            notify: function() {
                this.landscapeMobileListener = this.landscapeDesktopListener;
                this.portraitMobileListener = this.portraitDesktopListener;
            }
        },
        landscapeDesktopListener: {
            type: cc.Component.EventHandler,
            default: null
        },
        portraitDesktopListener: {
            type: cc.Component.EventHandler,
            default: null
        },
        landscapeMobileListener: {
            type: cc.Component.EventHandler,
            default: null
        },
        portraitMobileListener: {
            type: cc.Component.EventHandler,
            default: null
        }
    },

    onLoad () {
        this._super();
        this.isLoaded = true;

        if (this.lastConfig) {
            this._callListener(this[this.lastConfig]);
        }
    },

    onLandscapeMobile () {
        this.lastConfig = 'landscapeMobileListener';
        this._callListener(this.landscapeMobileListener);
    },

    onPortraitMobile () {
        this.lastConfig = 'portraitMobileListener';
        this._callListener(this.portraitMobileListener);
    },

    onLandscapeDesktop () {
        this.lastConfig = 'landscapeDesktopListener';
        this._callListener(this.landscapeDesktopListener);
    },

    onPortraitDesktop () {
        this.lastConfig = 'portraitDesktopListener';
        this._callListener(this.portraitDesktopListener);
    },

    _callListener (listener) {
        if (!this.isLoaded || !listener) {
            return;
        }

        // eslint-disable-next-line no-underscore-dangle
        const component = listener.target.getComponent(listener._componentName);
        const handler = component[listener.handler];

        handler.call(component, listener.customEventData);
    }
});
